import { isFeatureUnlocked } from "@/features/registry";
import useAccountMetadata from "@/hooks/useAccountMetadata";
import useFeatureFlags from "@/hooks/useFeatureFlag";

import { useHasSurveysEntitlement } from "./useHasSurveysEntitlement";

// Surveys is granted manually, so every surface that names it must be hidden
// from an account that cannot use it. Access needs both the Surveys
// entitlement and the CRO unlock. A transient entitlements lookup error fails
// open so an entitled account is not locked out by a blip.
export function useCanAccessSurveys(): {
  loading: boolean;
  canAccess: boolean;
} {
  const { loaded: accountLoaded } = useAccountMetadata();
  const flag = useFeatureFlags();
  const { loading, isError, hasEntitlement } = useHasSurveysEntitlement();

  return {
    loading: loading || !accountLoaded,
    canAccess:
      (hasEntitlement || isError) && isFeatureUnlocked("surveys", flag),
  };
}
